import React from 'react';
import PropTypes from 'prop-types';

import "../BrandRanking.css";

const PERIOD_OPTIONS = [
  { key: '1d', label: '일간' },
  { key: '1w', label: '주간' },
  { key: '1m', label: '월간' },
];

/**
 * 브랜드 랭킹 - 기간 탭
 * @param activePeriod
 * @param onChange
 * @returns {Element}
 * @constructor
 */
export default function PeriodTabs({ activePeriod, onChange }) {
  return (
    <div className="BrandRankingTabs">
      {PERIOD_OPTIONS.map((p) => (
        <button
          key={p.key}
          type="button"
          className={`BrandRankingTabs-item ${activePeriod === p.key ? 'active' : ''}`}
          onClick={() => onChange(p.key)}
        >
          {p.label}
        </button>
      ))}
    </div>
  );
}

PeriodTabs.propTypes = {
  activePeriod: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};
